module.exports = __webpack_public_path__ + "img/sprite.2b17a237.svg";